import React, { useState} from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import {
  Container,
  Typography,
  TextField,
  Button,
  Box,
  Alert,
  Paper,
  Grid
} from '@mui/material';

import { styled } from '@mui/system';
const StyledPaper = styled(Paper)(({ theme }) => ({ padding: theme.spacing(3) }));
const ForgotPassword = () => {
  const [step, setStep] = useState(1); // 1: Email, 2: OTP, 3: New Password
  const [formData, setFormData] = useState({
    email: '',
    otp: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const { email, otp, newPassword, confirmPassword } = formData;

  const onChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSendOTP = async e => {
    e.preventDefault();
    try {
      const res = await axios.post('/api/auth/forgot-password', { email });
      setSuccess(res.data.message);
      setError('');
      setStep(2);
    } catch (error) {
      setError(error.response?.data?.message || 'Error sending OTP');
      setSuccess('');
    }
  };

  const handleVerifyOTP = async e => {
    e.preventDefault();
    try {
      const res = await axios.post('/api/auth/verify-reset-otp', { email, otp });
      setSuccess(res.data.message);
      setError('');
      setStep(3);
    } catch (error) {
      setError(error.response?.data?.message || 'Error verifying OTP');
      setSuccess('');
    }
  };

  const handleResetPassword = async e => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    try {
      const res = await axios.post('/api/auth/reset-password', {
        email,
        otp,
        newPassword
      });
      setSuccess(res.data.message);
      setError('');
      // Redirect to login after successful password reset
      setTimeout(() => {
        window.location.href = '/login';
      }, 2000);
    } catch (error) {
      setError(error.response?.data?.message || 'Error resetting password');
      setSuccess('');
    }
  };

  return (
    <Container maxWidth="sm">
      <Grid container justifyContent="center">
        <Grid item xs={12}>
          <StyledPaper elevation={3}>
            <Typography variant="h5" align="center" color="primary" gutterBottom>
              {step === 1
                ? 'Forgot Password'
                : step === 2
                ? 'Enter OTP'
                : 'Reset Password'}
            </Typography>

            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}
            {success && (
              <Alert severity="success" sx={{ mb: 2 }}>
                {success}
              </Alert>
            )}

            {step === 1 && (
              <Box component="form" onSubmit={handleSendOTP} noValidate>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                  autoFocus
                  value={email}
                  onChange={onChange}
                />

                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                >
                  Send OTP
                </Button>
              </Box>
            )}

            {step === 2 && (
              <Box component="form" onSubmit={handleVerifyOTP} noValidate>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="otp"
                  label="Enter OTP"
                  type="text"
                  id="otp"
                  value={otp}
                  onChange={onChange}
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                >
                  Verify OTP
                </Button>
              </Box>
            )}

            {step === 3 && (
              <Box component="form" onSubmit={handleResetPassword} noValidate>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="newPassword"
                  label="New Password"
                  type="password"
                  id="newPassword"
                  autoComplete="new-password"
                  value={newPassword}
                  onChange={onChange}
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="confirmPassword"
                  label="Confirm Password"
                  type="password"
                  id="confirmPassword"
                  autoComplete="confirm-password"
                  value={confirmPassword}
                  onChange={onChange}
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                >
                  Reset Password
                </Button>
              </Box>
            )}

            <Box mt={3} align="center">
              <Link to="/login" style={{ textDecoration: 'none' }}>
                <Typography variant="body2" color="primary">
                  Back to Login
                </Typography>
              </Link>
            </Box>
          </StyledPaper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ForgotPassword;